import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <Helmet>
        <title>Sidan hittades inte – Currylicious Yum Yum</title>
        <meta name="description" content="Sidan du letar efter finns inte. Återgå till startsidan för Currylicious Yum Yum." />
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://www.currylicious.se/404" />
        <meta property="og:title" content="Sidan hittades inte – Currylicious Yum Yum" />
        <meta property="og:description" content="Sidan du letar efter finns inte." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.currylicious.se/404" />
      </Helmet>
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">Oops! Page not found</p>
        <a href="/" className="text-primary underline hover:text-primary/90">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
